// @flow
import React from 'react';
import classNames from 'classnames';
import { Button } from 'reactstrap';
import { withStyles } from '@material-ui/core/styles';
import { white, brandColor, brandColorDarker, textColor, green, grey, darkGrey } from '../../styles/style-constants';
import { remCalc, getPhoneMediaQueriedStyle } from '../../util/style-util';

type Props = {
  outline: boolean,
  size: string,
  onClick: Function,
  children: any,
  color: string,
  classes: Object
}

const GrowButton = ({ size, children, onClick, color, classes }: Props) => {
  const overrideClassName = color ? color : '';
  const defaultSize = size ? '' : classes.defaultSize;

  return (
    <Button
      className={classNames(classes.default, classes[overrideClassName], defaultSize)}
      size={size}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

const styles = {
  defaultSize: {
    width: remCalc(356),
    height: remCalc(58)
  },
  default: {
    color: white,
    fontSize: remCalc(16),
    lineHeight: remCalc(19),
    backgroundColor: brandColor,
    borderColor: brandColor,
    fontWeight: 600,
    borderRadius: 0,
    borderWidth: 3,
    '&:hover': {
      borderColor: brandColor,
      backgroundColor: brandColorDarker
    },
    ...getPhoneMediaQueriedStyle({
      width: 'auto',
      height: 'auto'
    })
  },
  outline: {
    color: brandColor,
    backgroundColor: white,
    borderColor: brandColor,
    '&:hover': {
      color: white,
      backgroundColor: brandColor
    }
  },
  success: {
    color: textColor,
    backgroundColor: green,
    borderColor: green,
    '&:hover': {
      color: textColor,
      backgroundColor: green,
      borderColor: green,
      filter: 'brightness(110%)'
    }
  },
  secondary: {
    color: darkGrey,
    backgroundColor: grey,
    borderColor: grey,
    '&:hover': {
      color: darkGrey,
      backgroundColor: grey,
      borderColor: grey,
      filter: 'brightness(90%)'
    }
  },
  landing: {
    color: white,
    backgroundColor: 'transparent',
    borderColor: white,
    borderWidth: 3,
    width: remCalc(230),
    '&:hover': {
      color: white,
      backgroundColor: 'transparent',
      borderColor: white,
      borderWidth: 4
    }
  }
};

export default withStyles(styles)(GrowButton);



// WEBPACK FOOTER //
// ./src/components/core/Button.js